import localFont from 'next/font/local';

// Why this file exists — and why it doesn't use getPublicImageUrl
// (`utils/staticFiles`):
//
// `getPublicImageUrl` builds a runtime HTTP URL (e.g. `/images/foo.svg`)
// for things like `<img src>` or CSS `background-image: url(...)`. That
// resolution happens in the browser at request time.
//
// `next/font/local` is fundamentally different: the `path` strings below
// are statically analyzed by Next.js's SWC plugin at build time, the
// font binaries are read from disk, hashed, copied to
// `_next/static/media/`, and the served URL is generated automatically
// (respecting `next.config.js`'s `assetPrefix`). Handing it a runtime
// URL would break that pipeline — there's nothing on disk at
// `/images/...` for the bundler to inline. So this module is the
// font-loading equivalent of `getPublicImageUrl`: same goal (centralize
// the public-asset path in one place), different mechanism because
// fonts go through Next's font pipeline, not the public-URL pipeline.
//
// Only Medium (500) and Bold (700) are referenced by the Foundation
// Figma's Title/Serif ramp (node 15482:12), so only those faces load.
// These constants live next to the loader so callers reference the same
// numbers registered with `next/font/local` — picking 600 ("bold"
// elsewhere in the app, i.e. Inter SemiBold) would miss the Romie Bold
// face and fall back via the browser's font-matching algorithm.
export const ROMIE_MEDIUM_WEIGHT = 500;
export const ROMIE_BOLD_WEIGHT = 700;

export const romie = localFont({
  src: [
    {
      path: '../../../public/fonts/Romie-Medium.woff2',
      weight: '500',
      style: 'normal',
    },
    {
      path: '../../../public/fonts/Romie-Bold.woff2',
      weight: '700',
      style: 'normal',
    },
  ],
  variable: '--font-romie',
  display: 'swap',
  fallback: ['Georgia', 'serif'],
});
